export default {"src":"/_next/static/media/gluten-free.c26c3c5a.svg","height":16,"width":16};